import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import {success, failed, hideModal} from "../actions/UserCreateActions";
import UserService from "../services/UserService";
import {USER_CREATE_LOAD} from "../constants/UserCreateConst";
import {loaduserlist} from "../actions/UserListActions";

export function* createuser() {
    yield takeEvery(USER_CREATE_LOAD, function* (payload) {
        try {
            const {data} = payload;
            const res = yield call(UserService.create,data);
            console.log('->>>>>>>>>>');
            yield put(success(res.data));
            yield put(hideModal());

            yield put(loaduserlist(res.data));
            console.log(res);
        } catch (err) {
            console.log('->>>>>>>>>> error');
            yield put(failed(err));
            console.log(err);
        }
    });
}


export default function* rootSaga() {
    yield all([
        fork(createuser)
    ]);
}
